import Layout from '@/layout/index.vue'
// import { RouteRecord } from 'vue-router'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import { staticRoute } from '@/router/staticRoute'
const ASSOCIATION_TAB_ID = 2
const associationOnlyRouteNames = new Set([
  'association_config',
  'association_config_list',
  'association_staff',
  'association_staff_list',
  'association_meeting',
  'association_meeting_list',
  'post_manage',
  'post_manage_list',
  'member_manage',
  'member_formal_list',
  'member_application_list',
  'company_manage_list',
  'safety_officer_mgmt',
  'safety_officer_list',
  'exam_manage_list',
  'association_advise',
  'association_advise_list'
])
const adminOnlyRouteNames = new Set([
  'association_staff',
  'association_staff_list'
])

const cloneRoutes = (routes: any[]): any[] => {
  return routes.map((route: any) => {
    const cloned = {
      ...route,
      meta: route.meta ? { ...route.meta } : route.meta
    }
    if (Array.isArray(route.children)) {
      cloned.children = cloneRoutes(route.children)
    }
    return cloned
  })
}

const syncAssociationRouteVisibility = (routes: any[]) => {
  const isAssociationTab = Number(AppModule.tabId) === ASSOCIATION_TAB_ID
  routes.forEach((route: any) => {
    const isAssociationRoute = associationOnlyRouteNames.has(route.name)
    const shouldHide = isAssociationTab ? !isAssociationRoute : isAssociationRoute

    if (isAssociationRoute || isAssociationTab) {
      const sidebarHidden = route.meta && route.meta.hidden === true
      route.hidden = shouldHide
      route.meta = {
        ...(route.meta || {}),
        hidden: shouldHide || sidebarHidden
      }
    }
    if (Array.isArray(route.children) && route.children.length) {
      syncAssociationRouteVisibility(route.children)
    }
  })
}

/** 协会成员菜单仅 admin 账号可见 */
const syncAdminOnlyRouteVisibility = (routes: any[]) => {
  const agentId = String(UserModule.userInfo?.agentId || '').trim()
  if (agentId === 'admin') return

  routes.forEach((route: any) => {
    if (adminOnlyRouteNames.has(route.name)) {
      route.hidden = true
      route.meta = {
        ...(route.meta || {}),
        hidden: true
      }
    }
    if (Array.isArray(route.children) && route.children.length) {
      syncAdminOnlyRouteVisibility(route.children)
    }
  })
}
// 前端路由表
const constantRoutesComponents:any = {
  401: () => import('@/views/main/error-page/401.vue'),
  404: () => import('@/views/main/error-page/404.vue'),
  Layout: () => import('@/layout/index.vue'),
  RouteView: Layout,
  PageView: Layout
}
// 前端未找到页面路由
const notFoundRouter = {
  path: '*', redirect: '/404', hidden: true
}
/**
 * 动态生成菜单
 * @param data
 * @returns {Promise<Router>}
 */
export const generatorDynamicRouter = () => {
  return new Promise((resolve) => {
    const routeSnapshot = cloneRoutes(staticRoute)
    syncAssociationRouteVisibility(routeSnapshot)
    syncAdminOnlyRouteVisibility(routeSnapshot)
    const visibleRoutes = routeSnapshot.filter((route: any) => !route.hidden && !route?.meta?.hidden)
    // 在这里 Number(AppModule.tabId) 对菜单进行筛选
    // console.log(staticRoute)
    visibleRoutes.push(notFoundRouter)
    // console.log(staticRoute)
    // Number(AppModule.tabId) 可以根据这个对菜单进行隐藏
    resolve(visibleRoutes)
  }).catch(err => {
    return Promise.reject(err)
  })
}
// export const generatorDynamicRouter = (menuList:object[]) => {
//   return new Promise((resolve) => {
//     const resNav:object[] = menuList
//     console.log(resNav)

//     const childrenNav:object[] = []
//     listToTree(resNav, childrenNav, 0)
//     console.log(childrenNav)
//     const routers = generator(childrenNav)
//     console.log(routers)

//     routers.push(notFoundRouter)
//     console.log(routers)

//     resolve(routers)
//   }).catch(err => {
//     return Promise.reject(err)
//   })
// }

/**
 * 格式化树形结构数据 生成vue-router层级路由表
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap:any) => {
  return routerMap.map((item:any) => {
    const { title, show, hideChildren, target, icon, link } = item.meta || {}
    const currentRouter:any = {
      path: item.meta.link || item.path,
      name: item.name || item.key || '',
      // component: (constantRoutesComponents[item.component]) || (() => import(`@/views/${item.component}.vue`)),
      component: (constantRoutesComponents[item.component]) || ((resolve:any) => require([`@/views/${item.component}.vue`], resolve)),
      meta: {
        title,
        icon,
        target,
        link,
        hidden: show === false || item.tabId !== Number(AppModule.tabId)
      }
    }
    if (show === false || item.tabId !== Number(AppModule.tabId)) {
      currentRouter.hidden = true
    }
    if (hideChildren) {
      currentRouter.hideChildrenInMenu = true
    }
    item.redirect && (currentRouter.redirect = item.redirect)
    if (item.children && item.children.length > 0) {
      currentRouter.children = generator(item.children)
    }
    return currentRouter
  })
}
/**
 * 数组转树形结构
 * @param list 源数据
 * @param tree 树
 * @param parentId
 */
const listToTree = (list:object[], tree:object[], parentId:number) => {
  list.forEach((item:any) => {
    if (item.pid === parentId) {
      const child = {
        ...item,
        key: item.key || item.name,
        children: []
      }
      listToTree(list, child.children, item.id)
      if (child.children.length <= 0) {
        delete child.children
      }
      tree.push(child)
    }
  })
}
